import type { Theme } from '@mui/material';

export const styles = {
  notificationIconWrapper: (active: boolean) => (theme: Theme) => ({
    position: 'relative',
    width: '1.5rem',
    height: '1.5rem',
    color: active ? theme.colors.neutral[800] : theme.colors.neutral[400],
  }),

  notificationIcon: {
    fontSize: '1.5rem',
  },

  notificationDot: (active: boolean) => (theme: Theme) => ({
    position: 'absolute',
    top: 1,
    right: -1,
    width: '0.75rem',
    height: '0.75rem',
    borderRadius: '50%',
    border: `2px solid ${theme.colors.white}`,
    backgroundColor: active
      ? theme.colors.primary[400]
      : theme.colors.neutral[400],
  }),
};
